<template>
  <Walkthrough 
    roomName="The Jail Cell"
    roomKey="jailcell"
    :steps="steps"
    :backgroundImage="backgroundImage"
  />
</template>
<script>

export default {
  name: 'JailCell',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/jailcell-1920x1280.jpg",
      steps: [
        "Look down and inspect the floor. You should find a wrench below a loose brick. ",
        "Look right and inspect the mirror. You should find an old nail file hidden there. ",
        "Look forward and inspect the bed. You'll find a prison outfit underneath it. ",
        "Now use the nail file on the bed. You scrape away some paint and find drawings of a mirror, sink, door, and vent underneath.  ",
        "Still looking forward, inspect the pillow, you should find a shiv. This will come in handy later. Make sure you don't forget to pick this one up. ;) ",
        "The images on the bed were actually clues. Using the direction that those items are found in the cell, you now know how to turn the wrench. Look right and then use the wrench on the pipe. Turn it right, right, left, then up. This should bring water flow back to the cell. ",
        "With water flowing, look forward again and use the prison outfit on the toilet to toss it in there. ",
        "With the prison outfit stuck in the toilet, use the toilet again. The water will begin to overflow and the rising water will take you to the vent where you use the shiv to open it and let yourself free. Congratulations you've escaped. Try solving the next room on your own! ",
        ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/jailcell.vue